import { gql } from '@apollo/client';
import { SH_PLAYER_FRAGMENT, ERROR_FRAGMENT } from './fragments.js';

export const GET_SH_PLAYERS = gql`
  query GetShPlayers($structureId: ID) {
    _SH_ {
      id
      players(filter: { structureId: $structureId }) {
        items {
          ...ShPlayerFields
        }
      }
    }
  }
  ${SH_PLAYER_FRAGMENT}
`;

export const GET_SH_PLAYER = gql`
  query GetShPlayer($id: ID!) {
    _SH_ {
      id
      player(id: $id) {
        ...ShPlayerFields
      }
    }
  }
  ${SH_PLAYER_FRAGMENT}
`;

export const UPDATE_SH_PLAYER = gql`
  mutation UpdateShPlayer($id: ID!, $input: _SH_UpdatePlayerInput!) {
    _SH_updatePlayer(id: $id, input: $input) {
      ok
      error {
        ...ErrorFields
      }
      player {
        ...ShPlayerFields
      }
    }
  }
  ${SH_PLAYER_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const GET_SH_PLAYER_STATS = gql`
  query GetShPlayerStats($playerId: ID!) {
    _SH_ {
      id
      playerStats(playerId: $playerId) {
        matchesPlayed
        matchesOrganized
        matchesThisWeek
        matchesLastWeek
      }
    }
  }
`;

export const CREATE_SH_PLAYER = gql`
  mutation CreateShPlayer($input: _SH_CreatePlayerInput!) {
    _SH_createPlayer(input: $input) {
      ok
      error {
        ...ErrorFields
      }
      player {
        ...ShPlayerFields
      }
    }
  }
  ${SH_PLAYER_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const DELETE_SH_PLAYER = gql`
  mutation DeleteShPlayer($id: ID!) {
    _SH_deletePlayer(id: $id) {
      ok
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const GET_SH_PLAYER_CAREER_POINTS = gql`
  query GetShPlayerCareerPoints($playerId: ID!, $cursor: ID, $limit: Int) {
    _SH_ {
      id
      playerCareerPoints(playerId: $playerId, cursor: $cursor, limit: $limit) {
        balance
        nextCursor
        items {
          id
          playerId
          delta
          source
          timestamp
          operationId
          note
          balanceAfter
        }
      }
    }
  }
`;

export const CHANGE_SH_PLAYER_CAREER_POINTS = gql`
  mutation ChangeShPlayerCareerPoints($input: _SH_ChangeCareerPointsInput!) {
    _SH_changePlayerCareerPoints(input: $input) {
      ok
      movement {
        id
        delta
        source
        timestamp
      }
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;
